var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionMarkSm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 0.5C2.23858 0.5 0 2.73858 0 5.5C0 8.26142 2.23858 10.5 5 10.5C7.76142 10.5 10 8.26142 10 5.5C9.99701 2.73981 7.76019 0.502985 5 0.5ZM5 8.41663C4.65482 8.41663 4.375 8.1368 4.375 7.79163C4.375 7.44645 4.65482 7.16663 5 7.16663C5.34518 7.16663 5.625 7.44645 5.625 7.79163C5.625 8.1368 5.34518 8.41663 5 8.41663ZM5.66658 5.88336C5.51467 5.94966 5.4165 6.0997 5.41658 6.26545C5.41658 6.49556 5.23004 6.68211 4.99992 6.68211C4.7698 6.68211 4.58325 6.49556 4.58325 6.26545C4.58318 5.76835 4.87766 5.31845 5.33325 5.11961C5.71476 4.95311 5.91489 4.53062 5.80205 4.12995C5.68921 3.72928 5.29801 3.47332 4.88568 3.53038C4.47335 3.58744 4.16637 3.94002 4.16659 4.35628C4.16659 4.5864 3.98004 4.77295 3.74992 4.77295C3.5198 4.77295 3.33325 4.5864 3.33325 4.35628C3.33324 3.52387 3.94741 2.81908 4.772 2.70524C5.59659 2.59141 6.37874 3.10344 6.60425 3.90472C6.82977 4.706 6.4295 5.55081 5.66658 5.88378V5.88336Z",
    fill: "#7C7C7C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMarkSm);
export default __webpack_public_path__ + "static/media/question-mark-sm.2de875eb.svg";
export { ForwardRef as ReactComponent };